import React from 'react';
import { useDispatch } from 'react-redux';
import FacebookAuthBtn from 'components/Social/FacebookLoginButton';
import GoogleLoginButton from 'components/Social/GoogleLoginButton';
import { fetchGoogleUser, addUser } from 'services/authService';
import * as action from "store/actions";
import {isMobile} from 'react-device-detect';

export default function LoginContainer(props) {
    const { setToggle } = props;
    const dispatch = useDispatch();
    let userInfo;

    const handleSocialLogin = (response) => {
        if(response.provider === 'google') {
            fetchGoogleUser({"access_token": response.access_token}).then(res => {
                userInfo = {
                    login_type: "Google",
                    login_id: res.sub,
                    login_token: res.sub,
                    login_name: res.name,
                    device: isMobile ? "m" : "pc",
                }
                dispatch(action.authUser(userInfo));
                const formData = new FormData();
                Object.keys(userInfo).map(function(key) {
                    return formData.append(key, userInfo[key]);
                });
        
                addUser(formData).then(res => {
                })
            }).catch(err => {
                // console.log(err)
            })
            
        }
        if(response.provider === 'facebook') {
            userInfo = {
                login_type: "FB",
                login_id: response.id,
                login_token: response.id,
                login_name: response.name,
                device: isMobile ? "m" : "pc",
            }
            dispatch(action.authUser(userInfo));

            const formData = new FormData();
            Object.keys(userInfo).map(function(key) {
                return formData.append(key, userInfo[key]);
            });
    
            addUser(formData).then(res => {
                // console.log(res);
            })
        }

        setToggle && setToggle(false);
    }



    return (
        <div className="login-container">
            <div className="d-flex align-items-stretch justify-content-center">
                <FacebookAuthBtn className="social-button facebook-login-button" defaultIcon={false} text="" callback={(res) => handleSocialLogin(res)} />
                <GoogleLoginButton className="social-button google-login-button" defaultIcon={false} text="" callback={(res) => handleSocialLogin(res)} />
            </div>
            <div className="login-button"></div>
        </div>
    )
}
